export default __webpack_public_path__ + "static/media/complementary--disabled-persons--g1.359b3b95.png";